var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniEtc01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#464497"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.11 205.361C154.175 212.594 168.875 213.706 178.21 213.706C185.99 213.265 188.833 209.54 188.572 207.924C188.096 204.993 189.128 203.164 185.08 198.768C181.033 194.372 157.451 179.354 146.012 174.409C134.573 169.463 122.068 167.335 117.327 172.028C114.037 175.284 114.679 180.902 117.327 185.935C119.38 189.842 128.11 199.189 140.11 205.361Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.608 144.193C244.235 155.097 258.681 154.141 264.88 154.141C275.406 153.817 278.883 149.12 278.64 147.708C278.2 145.144 279.156 143.545 275.406 139.702C271.655 135.858 249.806 122.725 239.207 118.401L239.159 118.382C228.565 114.059 214.348 108.259 209.962 112.356C206.914 115.203 208.284 123.988 210.737 128.389C213.19 132.789 216.114 137.7 226.608 144.193Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9555 136.013C89.7527 133.029 87.1816 126.869 87.1816 121.217C87.4793 113.433 89.5293 118.456 91.0836 118.456C92.6379 118.456 96.2051 124.933 97.2413 130.402C98.2775 135.871 122.907 162.398 102.836 147.541C97.614 143.676 94.126 138.952 91.9857 136.053L91.9555 136.013Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9746 121.892C88.7202 137.829 110.42 153.518 121.177 159.371L120.746 141.316C117.185 138.857 109 134.016 98.9114 125.03C90.8406 117.841 88.2574 105.022 87.9746 99.5117V121.892Z",
    fill: "#1F1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.209 159.401L120.764 141.759L124.134 139.312L124.318 156.513L121.209 159.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.745 156.521L121.447 144.304L123.612 142.533L123.777 154.681L121.745 156.521Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.745 156.516L121.447 144.299L131.636 149.995L130.201 161.248L121.745 156.516Z",
    fill: "#3B3563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.99 86.154C247.005 84.7904 246.735 81.6449 245.535 79.9727",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.806 85.929C248.094 84.3989 248.333 80.7295 246.988 78.293",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.133 208.554C194.682 208.876 193.314 209.224 191.455 208.037",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.377 207.49C195.943 207.724 194.839 207.964 193.885 207.055",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.861 189.336C205.211 189.498 203.281 189.726 200.768 189.336",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.025 188.035C205.339 188.215 203.545 188.468 201.854 188.035",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.957 199.25C195.364 199.956 196.595 201.439 198.26 201.726",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.354 198.424C195.593 198.998 196.452 200.196 197.974 200.398",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.431 132.844C156.9 132.047 150.661 136.499 148.482 138.825C154.611 158.577 162.797 199.703 163.683 205.816C164.79 213.459 188.286 215.073 195.043 208.87C200.552 204.391 205.706 195.735 206.52 184.348C207.185 175.048 201.647 158.43 192.786 148.461C183.925 138.493 173.846 133.84 164.431 132.844Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.862 137.173C147.598 137.984 147.371 140.058 146.311 141.419C156.58 164.359 175.448 210.007 178.812 211.064C183.015 212.385 192.598 206.683 195.853 196.279C198.779 188.231 197.358 177.183 194.871 170.399C190.065 157.291 180.3 146.199 170.697 140.644C160.91 134.982 152.31 136.814 150.862 137.173Z",
    fill: "#BBB7D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.533 138.261L134.262 147.022C134.13 159.524 136.085 186.842 144.967 196.099C156.07 207.671 165.687 210.251 174.053 211.58C182.418 212.909 187.71 207.062 189.289 205.168L189.334 205.114C191.578 202.424 197.291 195.573 195.463 179.546C191.134 159.577 178.457 147.969 169.641 142.309C161.832 137.294 152.427 137.243 148.533 138.261Z",
    fill: "#3F3A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.761 150.059L121.447 144.304L123.612 142.533L133.793 148.219L131.761 150.059Z",
    fill: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.926 102.033L219.922 78.7062L222.844 75.7129L222.848 99.2752L219.926 102.033Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.703 97.5073C105.886 104.673 98.9954 116.958 100.589 123.539C95.3909 118.33 93.4833 115.726 92.9806 113.295C91.3876 107.636 88.3378 98.1699 95.9837 90.4234C105.541 80.7404 117.062 74.8983 134.336 70.8198C148.862 67.3899 168.579 66.0827 187.309 68.6233C202.536 70.6886 216.11 75.4015 219.925 78.2097V101.805C214.542 100.058 209.34 97.4623 184.189 92.0556C159.038 86.6489 136.021 89.0445 119.703 97.5073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.82 144.515C127.627 145.32 127.109 161.394 128.048 169.503C129.657 178.416 134.07 184.985 139.14 191.091C155.261 209.669 170.099 206.649 173.453 204.897C177.004 203.043 185.61 195.167 183.238 181.91C181.415 171.723 172.679 160.889 168.896 157.046C165.047 153.137 154.988 143.768 141.82 144.515Z",
    fill: "#1F1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.269 152.782C127.579 153.012 128.035 166.657 130.099 173.451C135.14 188.217 148.191 198.425 153.359 200.668C159.231 203.217 171.722 202.612 174.674 194.115C177.627 185.618 173.919 177.46 173.22 175.923C172.862 175.137 160.632 152.494 142.269 152.782Z",
    fill: "#988DDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.749 87.3348L220.436 81.5794L222.6 79.8086L232.782 85.4943L230.749 87.3348Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.733 97.8977L220.436 81.5762L230.624 87.2726L229.189 102.629L220.733 97.8977Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16 139.306L120.761 141.752C101.768 132.013 93.0325 120.473 89.9817 112.282C84.2981 97.0298 92.3531 89.42 97.0894 85.0134C102.545 79.5037 118.267 68.7998 140.256 65.9472C151.872 64.4403 161.127 63.5477 174.708 64.3403C201.538 66.3442 217.962 72.7429 222.833 75.7118L219.889 78.7284C216.772 76.9471 205.508 73.2776 200.033 72.0406C191.923 70.3561 171.772 67.2864 156.05 68.4842C136.398 69.9815 127.859 72.3223 124.116 73.8196C120.373 75.3169 110.214 78.4365 101.917 85.5486C94.4795 91.9232 92.5088 95.6708 91.9306 99.4613C90.1135 118.328 113.328 134.048 124.16 139.306Z",
    fill: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.419 115.234C211.243 113.389 212.883 107.661 213.724 105.027L216.25 109.747L227.885 127.639C235.789 132.396 251.683 141.975 252.035 142.239C252.386 142.502 272.525 141.324 282.55 140.702C287.197 137.336 296.096 131.701 294.515 136.092C292.539 141.58 284.197 154.533 259.938 153.545C235.679 152.557 222.594 139.074 217.431 132.107C212.593 125.579 211.64 117.541 211.419 115.234Z",
    fill: "#3F3A5A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.293,
    cy: 113.124,
    rx: 45.4707,
    ry: 34.0711,
    transform: "rotate(22.8984 256.293 113.124)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.242 134.414C227.431 133.167 228.172 130.379 229.622 129.201",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.142,
    cy: 107.45,
    rx: 21.3383,
    ry: 12.9678,
    transform: "rotate(22.8984 257.142 107.45)",
    fill: "#534B7E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.264,
    cy: 110.391,
    rx: 18.2388,
    ry: 11.0842,
    transform: "rotate(22.8984 259.264 110.391)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.725 125.778C267.949 132.63 284.478 130.193 288.642 120.333C292.807 110.473 283.031 96.9249 266.807 90.0721C250.582 83.2193 234.054 85.6569 229.889 95.5167C225.725 105.377 235.501 118.925 251.725 125.778ZM254.953 118.137C264.233 122.056 273.686 120.662 276.068 115.023C278.45 109.383 272.858 101.635 263.579 97.7153C254.3 93.7959 244.847 95.1901 242.465 100.829C240.083 106.469 245.674 114.217 254.953 118.137Z",
    fill: "#988DDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.707 109.467C213.186 107.607 214.876 103.564 217.805 102.275",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.59 113.792C213.816 112.129 214.734 108.578 216.593 107.672",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.83 133.283C226.227 131.243 227.848 126.54 231.156 124.047",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.496 132.012C224.601 130.072 225.59 125.832 228.702 124.387",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.687 125.881C251.721 127.206 251.446 130.31 250.076 132.124",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.957 126.432C253.108 126.969 253.319 128.345 252.957 129.553",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.982 141.406C184.412 141.487 183.184 141.902 182.832 142.919",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.053 140.652C183.171 140.956 181.225 141.88 180.5 143.148",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.102 160.334C199.431 160.539 197.703 161.183 196.154 162.112",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.858 161.33C200.342 161.503 199.091 162.017 198.213 162.687",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.097 136.669C160.027 136.008 160.257 134.509 161.744 133.799",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.939 136.923C160.982 136.43 161.279 135.342 162.123 134.938",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.654 142.286C173.851 141.694 174.491 140.469 175.47 140.301",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.801 156.563C188.279 155.93 189.549 154.613 190.799 154.41",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.139 157.07C188.589 156.619 189.676 155.667 190.42 155.465",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.502 172.498L141.033 164.686L144.098 166.855C145.873 168.112 146.117 169.929 145.028 171.467C143.924 173.026 142.128 173.366 140.326 172.09L138.923 171.097L137.12 173.644L135.502 172.498ZM139.848 169.792L140.992 170.601C141.952 171.281 142.803 171.074 143.356 170.283C143.911 169.51 143.812 168.654 142.856 167.969L141.712 167.159L139.848 169.792Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 177.851C142.35 177.492 142.226 176.797 142.592 176.303C142.933 175.799 143.629 175.685 144.133 176.049C144.617 176.384 144.746 177.082 144.394 177.579C144.039 178.081 143.337 178.191 142.857 177.851Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.138 179.32L150.669 171.508L153.733 173.678C155.508 174.935 155.753 176.752 154.664 178.289C153.56 179.849 151.764 180.189 149.962 178.913L148.559 177.92L146.756 180.466L145.138 179.32ZM149.484 176.614L150.627 177.424C151.588 178.104 152.439 177.897 152.991 177.105C153.547 176.332 153.448 175.476 152.492 174.791L151.348 173.981L149.484 176.614Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.118 177.49L153.586 185.302L151.989 184.172L157.521 176.359L159.118 177.49Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.398 188.179C155.605 186.902 155.326 184.962 156.645 183.11C157.919 181.299 159.903 180.865 161.619 182.08C163.157 183.168 163.683 184.999 162.269 186.995L161.949 187.448L157.945 184.614C157.319 185.499 157.456 186.414 158.278 187.004C158.827 187.385 159.383 187.422 159.788 187.182L161.309 188.26C160.315 189.184 158.847 189.197 157.398 188.179ZM158.656 183.611L161.148 185.375C161.647 184.659 161.519 183.799 160.803 183.3C160.073 182.776 159.166 182.959 158.656 183.611Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.607 242.453V222.656H190.373C194.871 222.656 197.455 225.432 197.455 229.328C197.455 233.279 194.83 236 190.264 236H186.709V242.453H182.607ZM186.709 232.691H189.607C192.041 232.691 193.23 231.324 193.217 229.328C193.23 227.359 192.041 226.033 189.607 226.02H186.709V232.691ZM201.42 242.699C200.135 242.699 199.096 241.674 199.123 240.402C199.096 239.145 200.135 238.119 201.42 238.133C202.637 238.119 203.689 239.145 203.689 240.402C203.689 241.674 202.637 242.699 201.42 242.699ZM207.025 242.453V222.656H214.791C219.289 222.656 221.873 225.432 221.873 229.328C221.873 233.279 219.248 236 214.682 236H211.127V242.453H207.025ZM211.127 232.691H214.025C216.459 232.691 217.648 231.324 217.635 229.328C217.648 227.359 216.459 226.033 214.025 226.02H211.127V232.691ZM228.436 222.656V242.453H224.389V222.656H228.436ZM238.307 242.754C233.754 242.74 230.965 239.801 230.979 235.098C230.965 230.518 233.795 227.414 238.143 227.414C242.039 227.414 245.115 229.875 245.115 234.934V236.082H234.971C234.971 238.324 236.297 239.705 238.389 239.719C239.77 239.705 240.754 239.104 241.15 238.215H245.006C244.432 240.963 241.971 242.74 238.307 242.754ZM234.971 233.539H241.287C241.273 231.734 240.029 230.436 238.225 230.449C236.365 230.436 235.053 231.83 234.971 233.539Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniEtc01);
export default __webpack_public_path__ + "static/media/mini_etc_01.f40d59b52ad5fce59d6b7918951b45ec.svg";
export { ForwardRef as ReactComponent };